/**
 * Centralized API Route Constants
 * Prevents hardcoded route mismatches
 */

export const API_ROUTES = {
  // User & Auth
  USER_ME: '/user/me',
  USER_PROFILE: '/user/profile',
  USER_SUBSCRIPTION: '/user/subscription',
  USER_SETTINGS: '/user/settings',
  USER_AVATAR: '/user/avatar',
  USER_INVITES_COUNT: '/user/invites/count',
  USER_PENDING_INVITE: '/user/pending-invite',
  USER_ACCEPT_INVITE: '/user/accept-invite',
  USER_INITIALIZE_COMPANY: '/user/initialize-company',
  USER_CREATE_REFERRAL: '/user/create-referral',
  USER_APPLY_REFERRAL: '/user/apply-referral',
  USER_VALIDATE_REFERRAL: '/user/validate-referral',

  // Customers
  CUSTOMERS: '/customers',
  CUSTOMER_BY_ID: (id: string) => `/customers/${id}`,

  // Calendar
  CALENDAR_EVENTS: '/calendar/events',

  // Notifications
  NOTIFICATIONS: '/notifications',
  NOTIFICATIONS_MARK_READ: (id: string) => `/notifications/${id}/read`,
  NOTIFICATIONS_READ_ALL: '/notifications/read-all',
  NOTIFICATIONS_DELETE: (id: string) => `/notifications/${id}`,

  // Call Management
  CREATE_CALL: '/create-call',
  JOIN_CALL: '/join-call',
  CALL_HISTORY: '/calls/history',
  CALL_DETAILS: (roomId: string) => `/calls/history/${roomId}`,
  UPDATE_CALL_SESSION: '/update-call-session',

  // Projects
  PROJECTS: '/projects',
  PROJECT_BY_ID: (id: string) => `/projects/${id}`,

  // Team
  TEAM_MEMBERS: '/team/members',

  // Billing
  BILLING_USAGE: '/billing/usage',
  BILLING_CUSTOMER_PORTAL: '/billing/customer-portal',
  BILLING_PAUSE: '/billing/pause',
  BILLING_RESUME: '/billing/resume',
  BILLING_CANCEL: '/billing/cancel',

  // Invoices
  INVOICES: '/invoices',

  // Call Reports
  CALL_REPORTS_CREATE: '/call-reports',
  CALL_REPORTS_LIST: '/call-reports',
  CALL_REPORTS_GET: (id: string) => `/call-reports/${id}`,

  // Device Tracking
  DEVICES_LIST: '/devices',
  DEVICES_TRACK: '/devices/track',

  // Scheduled Calls
  SCHEDULED_CALLS_CREATE: '/scheduled-calls',
  SCHEDULED_CALLS_LIST: '/scheduled-calls',
  SCHEDULED_CALLS_UPDATE: (id: string) => `/scheduled-calls/${id}`,
  SCHEDULED_CALLS_DELETE: (id: string) => `/scheduled-calls/${id}`,

  // Public Intake
  INTAKE_REQUESTS: '/intake/requests',

  // Session Notes
  SESSION_NOTES_UPDATE: (roomId: string) => `/sessions/${roomId}/notes`,

  // Recording Requests (already exists on backend, adding route)
  RECORDING_REQUEST: '/request-recording',

  // Google Calendar Integration
  GOOGLE_CALENDAR_AUTH_URL: '/google-calendar/auth-url',
  GOOGLE_CALENDAR_CONNECT: '/google-calendar/connect',
  GOOGLE_CALENDAR_STATUS: '/google-calendar/status',
  GOOGLE_CALENDAR_DISCONNECT: '/google-calendar/disconnect',
} as const;

/**
 * Helper to replace route parameters
 */
export function replaceRouteParams(
  route: string,
  params: Record<string, string>
): string {
  let result = route;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`:${key}`, value);
  });
  return result;
}
